<template>
  <div class="addWhiteIp" style="margin-top: 2%;">
    <el-dialog :title="dialogTitle" :visible.sync="isAddWhiteIp"  :close-on-click-modal ="false" align="left" width="30%" @close="close">
      <el-form :model="addIPForm" ref="addIPForm" :rules="rules">
        <el-form-item label="IP Address" prop="IP">
          <el-input v-model="addIPForm.IP"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('addIPForm')">Save</el-button>
          <el-button @click="resetForm('addIPForm')">Reset</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
    export default {
        name: "whiteIpList",
        props:{
          editWhiteIP:{
            type:Object,
            default:{}
          },
          isEdit:{
            type:Boolean,
            default:false
          }
        },
        data(){
          //IP验证
          let validateIP = (rule, value, callback) => {
            var reg = /(?=(\b|\D))(((\d{1,2})|(1\d{1,2})|(2[0-4]\d)|(25[0-5]))\.){3}((\d{1,2})|(1\d{1,2})|(2[0-4]\d)|(25[0-5]))(?=(\b|\D))/
            if (value === '') {
              callback(new Error('请输入IP'));
            } else if (!reg.test(value)) {
              callback(new Error('IP不符合规范'));
            }else{
              callback();
            }
          };

          return {
            isAddWhiteIp:true,
            addIPForm:{
              IP:''
            },
            dialogTitle:"Add White IP",
            rules: {
              IP: [
                { validator: validateIP, trigger: 'blur' },
              ]
            },
          }
        },
        created(){
          if(this.isEdit && this.editWhiteIP.ipAddr  && JSON.stringify(this.editWhiteIP.ipAddr) !== '{}'){
            this.dialogTitle = "Edit White IP";
            this.addIPForm.IP = this.editWhiteIP.ipAddr;
          }
      },
      methods:{
        submitForm(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              if(this.isEdit){
                //编辑
                this.$axios({ 
                    method:'POST',
                    url:'/hdars/hdars/ip/modifyIp/' + this.editWhiteIP.id + '/' + this.addIPForm.IP
                  }).then(() => {
                    this.close();
                    this.$emit('query');
                })
              }else{
                this.$axios({ 
                    method:'POST',
                    url:'/hdars/hdars/ip/saveWhiteIP/' + this.addIPForm.IP
                  }).then((response) => {
                  this.gridData = response.data;
                  this.close();
                  this.$emit('query');
                })
              }
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        resetForm:function() {
          this.addIPForm.IP = '';
        },
        close:function(){
          this.$emit('close');
        }
      }
    }

</script>

<style>
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
  .addWhiteIp .el-form-item__label{width:90px;}
  .addWhiteIp .el-form-item__content{margin-left:90px}
</style>



// WEBPACK FOOTER //
// src/page/activePublic/userManagement/addWhiteIpList.vue